import { AuthBody, LoginResponse } from '../models/AuthBody';
import cookieService, { COOKIE_KEYS } from './cookieService';
import downloadService from './downloadService';
import { User } from '../models/User';
import localStorageService, { LOCAL_STORAGE_KEYS } from './localStorageService';

export default {
  get token() {
    return cookieService.getItem<string>(COOKIE_KEYS.TOKEN);
  },

  set token(token: string) {
    cookieService.setItem(COOKIE_KEYS.TOKEN, token);
  },

  removeToken() {
    cookieService.removeItem(COOKIE_KEYS.TOKEN);
  },

  get refreshToken() {
    return cookieService.getItem<string>(COOKIE_KEYS.REFRESH_TOKEN);
  },

  set refreshToken(refreshToken: string) {
    cookieService.setItem(COOKIE_KEYS.REFRESH_TOKEN, refreshToken);
  },

  removeRefreshToken() {
    cookieService.removeItem(COOKIE_KEYS.REFRESH_TOKEN);
  },

  get currentUserId() {
    return cookieService.getItem<string>(COOKIE_KEYS.CURRENT_USER_ID);
  },

  set currentUserId(currentUserId: string) {
    cookieService.setItem(COOKIE_KEYS.CURRENT_USER_ID, currentUserId);
  },

  removeCurrentUserId() {
    cookieService.removeItem(COOKIE_KEYS.CURRENT_USER_ID);
  },

  get currentUser() {
    return localStorageService.getItem<User>(LOCAL_STORAGE_KEYS.CURRENT_USER);
  },

  set currentUser(user: User) {
    if (user) {
      localStorageService.setItem(LOCAL_STORAGE_KEYS.CURRENT_USER, user);
    } else {
      this.removeCurrentUser();
    }
  },

  removeCurrentUser() {
    localStorageService.removeItem(LOCAL_STORAGE_KEYS.CURRENT_USER);
  },

  get hasJustRegistered() {
    return cookieService.getItem<string>(COOKIE_KEYS.HAS_JUST_REGISTERED);
  },

  justRegistered() {
    // used for phone number verification reminder
    cookieService.setItem(COOKIE_KEYS.HAS_JUST_REGISTERED, 'true');
  },

  removeHasJustRegistered() {
    cookieService.removeItem(COOKIE_KEYS.HAS_JUST_REGISTERED);
  },

  get rfiToken() {
    return cookieService.getItem<string>(COOKIE_KEYS.RFI_TOKEN);
  },

  set rfiToken(token: string) {
    cookieService.setItem(COOKIE_KEYS.RFI_TOKEN, token);
  },

  removeRfiToken() {
    cookieService.removeItem(COOKIE_KEYS.RFI_TOKEN);
  },

  saveTwoFa(twoFaProps: Omit<LoginResponse, 'token' | 'refreshToken'>) {
    cookieService.setItem(
      COOKIE_KEYS.IS_CONF_TFA,
      twoFaProps.isConfiguredTwoFactorAuth,
    );
    cookieService.setItem(COOKIE_KEYS.UID, twoFaProps.user._id);
    cookieService.setItem(COOKIE_KEYS.OT_PATH, twoFaProps.otpauth_url);
  },

  get twoFaProps() {
    return {
      [COOKIE_KEYS.IS_CONF_TFA]: cookieService.getItem<string>(
        COOKIE_KEYS.IS_CONF_TFA,
      ),
      [COOKIE_KEYS.OT_PATH]: cookieService.getItem<string>(COOKIE_KEYS.OT_PATH),
      [COOKIE_KEYS.UID]: cookieService.getItem<string>(COOKIE_KEYS.UID),
    };
  },

  saveAuthBody({ token, refreshToken, user }: AuthBody) {
    this.token = token;
    this.refreshToken = refreshToken;
    this.currentUserId = user?._id;
    this.currentUser = user;
  },

  removeAuthBody() {
    this.removeToken();
    this.removeRefreshToken();
    this.removeCurrentUserId();
    this.removeCurrentUser();
    this.removeHasJustRegistered();
    downloadService.removeDownloadUniqueId();
  },
};
